import { render, staticRenderFns } from "./module-box.vue?vue&type=template&id=0f5494ae&"
import script from "./module-box.vue?vue&type=script&lang=js&"
export * from "./module-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports